module.exports = __webpack_public_path__ + "img/josh-profilePix.72672410.jpg";